import { useEffect, useState } from "react";
import KanbanColumn from "./KanbanColumn";
import crudApi from "@serie3/common/api/crudApi";
import listHandler from "@serie3/common/Domain/listHandler";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const KanbanBoard = ({
  setEditAction,
  actions,
  setShowForm,
  setViewAction,
  setActions,
  showError,
  containerStyle,
  deleteUrl,
  includeDone,
}) => {
  const [backlog, setBacklog] = useState([]);
  const [onHold, setOnHold] = useState([]);
  const [inProgress, setInProgress] = useState([]);
  const [todo, setTodo] = useState([]);
  const [waiting, setWaiting] = useState([]);
  const [done, setDone] = useState([]);
  const [canceled, setCanceled] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [activeColumn, setActiveColumn] = useState("Todo");

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const deleteData = async (id, index, setDataList, dataList) => {

    let deleteEndpoint = "/crm/tickets/delete/";
    if (typeof deleteUrl !== "undefined") {
      deleteEndpoint = deleteUrl;
    }
    listHandler.deleteFromList(
      index,
      crudApi.del(deleteEndpoint, id),
      setDataList,
      dataList,
      showError
    );
  };

  useEffect(() => {
    const tmpBacklog = [];
    const tmpTodo = [];
    const tmpInProgress = [];
    const tmpOnHold = [];
    const tmpWaiting = [];
    const tmpDone = [];
    const tmpCanceled = [];

    actions.map((action) => {
      switch (action.status) {
        case "Backlog":
          tmpBacklog.push(action);
          break;
        case "Created":
          tmpTodo.push(action);
          break;
        case "In_Progress":
          tmpInProgress.push(action);
          break;
        case "On_Hold":
          tmpOnHold.push(action);
          break;
        case "Waiting":
          tmpWaiting.push(action);
          break;
        case "Done":
          tmpDone.push(action);
          break;
        case "Canceled":
          tmpCanceled.push(action);
          break;
        default:
          tmpTodo.push(action);
          break;
      }
    });

    setBacklog(tmpBacklog);
    setTodo(tmpTodo);
    setInProgress(tmpInProgress);
    setOnHold(tmpOnHold);
    setWaiting(tmpWaiting);
    setDone(tmpDone);
    setCanceled(tmpCanceled);
  }, [actions]);

  const columns = includeDone ? [
    { title: "Done",     type: "card-row card-success", dataList: done,     setDataList: setDone },
    { title: "Canceled", type: "card-row card-danger",  dataList: canceled, setDataList: setCanceled },
  ] : [
    { title: "Backlog",     type: "card-row card-secondary",  dataList: backlog,    setDataList: setBacklog },
    { title: "Todo",        type: "card-row card-primary",    dataList: todo,       setDataList: setTodo },
    { title: "In Progress", type: "card-row card-info",       dataList: inProgress, setDataList: setInProgress },
    { title: "Waiting",     type: "card-row card-warning",    dataList: waiting,    setDataList: setWaiting },
    { title: "On Hold",     type: "card-row card-secondary",  dataList: onHold,     setDataList: setOnHold },
  ];

  const sharedProps = { setEditAction, setShowForm, setViewAction, deleteData };

  if (isMobile) {
    const active = columns.find((c) => c.title === activeColumn) || columns[0];
    return (
      <div style={{ width: "100%" }}>
        <div style={{ position: "relative", marginBottom: "14px" }}>
          <select
            value={activeColumn}
            onChange={(e) => setActiveColumn(e.target.value)}
            style={{
              width: "100%", appearance: "none", padding: "10px 36px 10px 14px",
              border: "1px solid #c5d8fb", borderRadius: "10px",
              background: "#f5f8ff", color: "#212121",
              fontSize: "0.95rem", fontWeight: 600, cursor: "pointer", outline: "none",
            }}
          >
            {columns.map((c) => (
              <option key={c.title} value={c.title}>
                {c.title} ({c.dataList.length})
              </option>
            ))}
          </select>
          <FontAwesomeIcon
            icon={faChevronDown}
            style={{
              position: "absolute", right: "14px", top: "50%", transform: "translateY(-50%)",
              color: "#1a73e8", fontSize: "0.75rem", pointerEvents: "none",
            }}
          />
        </div>
        <KanbanColumn
          title={active.title}
          type={active.type}
          dataList={active.dataList}
          setDataList={active.setDataList}
          {...sharedProps}
        />
      </div>
    );
  }

  return (
    <div style={{ display: "flex", gap: "16px", alignItems: "flex-start", width: "100%", ...containerStyle }}>
      {columns.map((c) => (
        <KanbanColumn
          key={c.title}
          title={c.title}
          type={c.type}
          dataList={c.dataList}
          setDataList={c.setDataList}
          {...sharedProps}
        />
      ))}
    </div>
  );
};

export default KanbanBoard;
